import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Header from '../../Shared/Header/Header';
import AboutMe from '../AboutMe/AboutMe';
import Banner from '../Banner/Banner';
import Contact from '../Contact/Contact';
import Portfolio from '../Portfolio/Portfolio/Portfolio';
import Skills from '../Skills/Skills';


const Home = () => {
    return (
        <div className="overflow-hidden">
            <Header />
            <Banner />
            <AboutMe />
            <Skills/>
            <Portfolio />
            <Contact />
            <Footer />
         
        </div>
    );
};

export default Home;